<template>
  <div class="w-full bg-slate-50 min-h-screen p-4" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-slate-700">Reajuste de Valores</h1>
        <p class="text-sm text-slate-500">Reajustar valor dos abastecimentos realizados</p>
      </div>

      <!-- FORMULÁRIO DE REAJUSTE -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-custom mb-8">
          <div class="px-6 py-4" style="background-color: #333333;">
              <h2 class="text-white font-bold flex items-center gap-2 uppercase tracking-widest text-[11px]">
                  <v-icon color="orange" small class="mr-2">mdi-cash-edit</v-icon>
                  CONFIGURAÇÕES DO REAJUSTE
              </h2>
          </div>
          <div class="px-6 pt-6 pb-10">
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(itemNewValues.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <Date
                    @dateValue="[(itemNewValues.endDate = $event)]"
                    label="Data Final"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    label="Critério de Filtro"
                    :items="[
                      'PELAS DATAS SOMENTE',
                      'DATAS E INTERVALO DE HORAS',
                    ]"
                    v-model="itemNewValues.filterOption"
                    outlined
                    dense
                  />
                </v-col>
                
                <template v-if="itemNewValues.filterOption == 'DATAS E INTERVALO DE HORAS'">
                  <v-col cols="12" sm="12" md="3">
                    <v-text-field
                      label="Hora Inicial"
                      v-mask="'00:00'"
                      placeholder="00:00"
                      v-model="itemNewValues.startHour"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-text-field
                      label="Hora Final"
                      v-mask="'00:00'"
                      placeholder="00:00"
                      v-model="itemNewValues.endHour"
                      outlined
                      dense
                    />
                  </v-col>
                </template>

                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="itemNewValues.prefecture_id"
                    label="Prefeitura"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    clearable
                    outlined
                    dense
                    @change="[getProviders()]"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    v-model="itemNewValues.provider_id"
                    label="Participante (Fornecedor)"
                    :items="providers"
                    item-text="provider_name"
                    item-value="provider_id"
                    clearable
                    outlined
                    dense
                    @change="getItems"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    label="Item (Combustível/Serviço)"
                    :items="items"
                    item-value="item_id"
                    item-text="item_description_desc"
                    v-model="itemNewValues.item_id"
                    outlined
                    dense
                    @change="getItemValue(itemNewValues.item_id)"
                  >
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.item_description_desc }} - R$ {{ realMaskII(item.item_price.toFixed(3)) }}
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      {{ item.item_description_desc }} - R$ {{ realMaskII(item.item_price.toFixed(3)) }}
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    label="Valor Atual"
                    v-mask-decimal.br="3"
                    v-model="itemNewValues.itemCurrentValue"
                    outlined
                    dense
                    readonly
                    background-color="slate-50"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    label="Novo Valor"
                    v-mask-decimal.br="3"
                    v-model="itemNewValues.itemNewValue"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    label="Alterar valor do item na licitação?"
                    v-model="itemNewValues.newValueBidding"
                    hide-details
                    class="mt-0"
                  />
                </v-col>
              </v-row>

              <div class="flex justify-end mt-8">
                  <button 
                    @click="readjustValues" 
                    :disabled="!isFormValid"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 flex items-center justify-center gap-2 w-fit whitespace-nowrap px-8 h-10 transition-all transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed text-[11px] font-bold uppercase tracking-widest"
                  >
                      <v-icon color="white" small class="mr-1">mdi-check-circle-outline</v-icon>
                      APLICAR REAJUSTE
                  </button>
              </div>
          </div>
      </section>

      <v-snackbar
        multi-line
        :color="snack.color"
        v-model="snack.show"
        transition="fade-transition"
        top
        right
      >
        {{ snack.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snack.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    secretariats: [],
    providers: [],
    items: [],
    itemNewValues: {
      itemCurrentValue: 0,
      itemNewValue: 0,
      newValueBidding: false,
      item_id: null,
      prefecture_id: null,
      provider_id: null,
      startDate: null,
      endDate: null,
      startHour: "",
      endHour: "",
      filterOption: "PELAS DATAS SOMENTE",
    },
    dataSupplies: [],
    selectedSupplies: [],
    headers: [
      { text: "Data/Hora", value: "datehour", sortable: false },
      { text: "Item", value: "item_description_desc", sortable: false },
      {
        text: "Litros Abastecidos",
        value: "supply_liters_stocked",
        sortable: false,
      },
      {
        text: "Valor",
        value: "supply_price_day",
        sortable: false,
      },
      { text: "Total", value: "supply_value", sortable: false },
      { text: "Senha", value: "supply_code", sortable: false },
      { text: "Status", value: "supply_status", sortable: false },
      { text: "Corrigido", value: "supply_ajusted", sortable: false },
      { text: "Faturado", value: "supply_billed", sortable: false },
    ],
    loader: false,
    resultAverage: null,
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  computed: {
    isFormValid() {
      return (
        this.itemNewValues.startDate &&
        this.itemNewValues.endDate &&
        this.itemNewValues.prefecture_id &&
        this.itemNewValues.provider_id &&
        this.itemNewValues.item_id &&
        this.itemNewValues.itemNewValue
      );
    },
  },
  methods: {
    getProviders() {
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/readjust/providers/${this.itemNewValues.prefecture_id}`)
        .then((r) => {
          this.providers = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getItems() {
      this.itemNewValues.vehicle_id = null;
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
      .get(`/supplies/providers/prefectures/${this.itemNewValues.provider_id}/${this.itemNewValues.prefecture_id}/${this.itemNewValues.startDate}/${this.itemNewValues.endDate}`).then((r) => {
          this.items = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getItemValue(id) {
      const items = [...this.items];
      const item = items.find((item) => item.item_id == id);
      this.itemNewValues.itemCurrentValue = item.item_price.toFixed(3);
    },
    emptyValues() {
      this.itemNewValues.itemCurrentValue = 0;
      this.itemNewValues.itemNewValue = 0;
      this.itemNewValues.item_id = null;
      this.itemNewValues.prefecture_id = null;
      this.itemNewValues.provider_id = null;
      this.itemNewValues.startDate = null;
      this.itemNewValues.endDate = null;
      this.itemNewValues.startHour = null;
      this.itemNewValues.endHour = null;
      this.itemNewValues.filterOption = 'PELAS DATAS SOMENTE';
    },
    getData() {
      if (this.itemNewValues.prefecture_id) {
        this.dataSupplies = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post(`/distribution/econferences/data`, this.itemNewValues)
          .then((supplies) => {
            this.dataSupplies = supplies.data;
            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    readjustValues() {
      let c = confirm("Essa operação não poderá ser desfeita! Deseja continuar?");
      if (c) {
        this.$http
          .put("/readjust", this.itemNewValues)
          .then((r) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.emptyValues();
            this.snack.type = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
  },
};
</script>

<style>
</style>